module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMuNTQwMjggNi40NTk2NEw0LjQ1OTUyIDUuNTQwNDFMNy45OTk5IDkuMDgwNzlMMTEuNTQwMyA1LjU0MDQxTDEyLjQ1OTUgNi40NTk2NEw3Ljk5OTkgMTAuOTE5M0wzLjU0MDI4IDYuNDU5NjRaIiBmaWxsPSIjMzMzMzMzIi8+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./static/img/docCenter/arrow_down.svg
// module id = Tzsa
// module chunks = 1